import Vue from 'vue';
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate);
import {validationMixin} from 'vuelidate';
import {required, email} from 'vuelidate/lib/validators';

import {mapActions, mapGetters, mapMutations} from "vuex";

import {
    SET_DATA_REMOVE_FROM_FAVORITES,
    CHANGE_POPUP_FAVORITES_REMOVE_LIST
} from '@/store/mutation-types'
import {
    REMOVE_FAVORITE_LIST,
    GET_FAVORITES_LIST
} from '@/store/action-types'

export default {
    name: 'remove-list-from-favorites',
    mixin: [validationMixin],
    computed: {
        ...mapGetters({
            loadingRemoveList: 'favorites/loadingRemoveList',
            whichList: 'favorites/whichList',
        }),
        transformWhichList() {
            let result = [];
            this.whichList.forEach(e => {
                result.push(e.id)
            });
            return result;
        }
    },
    methods: {
        ...mapActions({
            remove: `favorites/${REMOVE_FAVORITE_LIST}`,
            fetchFavorites: `favorites/${GET_FAVORITES_LIST}`
        }),
        ...mapMutations({
            changeShowRemovePopup: `favorites/${CHANGE_POPUP_FAVORITES_REMOVE_LIST}`,
        }),
        removeList() {
            this.remove()
                .then(() => {
                    this.$toasted.success(this.$t('successRemoveList')).goAway(5000);
                    this.changeShowRemovePopup({ id: '', show: false });
                })
                .catch(error => {
                    if (error.response.status !== 422){
                        this.fetchFavorites({ list: this.transformWhichList })
                        this.$toasted.error(error.response.data.error).goAway(5000);
                    }
                })
        },
        cancel() {
            this.changeShowRemovePopup({ id: '', show: false });
        }
    }
}
